import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.519 17.259l4.669 4.74h-6.242l-1.561-1.624 3.134-3.116zM3 11.987L13.075 2h6.295L6.146 15.13 3 11.986zm4.554 4.592l5.417-5.396h6.283l-8.558 8.538-3.142-3.142z"
    />
  </svg>
);
